import { ShieldCheck } from "lucide-react";

import { cn } from "@/lib/utils";

type AppLogoProps = {
  className?: string;
  compact?: boolean;
  primaryLabel?: string;
  secondaryLabel?: string;
  // ponytail: "onDark" for navy/dark surfaces (login panel, footer); inherits theme otherwise
  tone?: "default" | "onDark";
};

export const AppLogo = ({
  className,
  compact = false,
  primaryLabel = "TaxOS Console",
  secondaryLabel = "by Tuzidi",
  tone = "default",
}: AppLogoProps) => {
  const onDark = tone === "onDark";
  return (
    <div className={cn("flex items-center gap-2", className)} role="banner" aria-label="Application logo">
      <span
        className={cn(
          "flex h-7 w-7 shrink-0 items-center justify-center rounded-md border",
          onDark ? "border-white/20 bg-white/10" : "border-border bg-muted/40",
        )}
      >
        <ShieldCheck className={cn("h-4 w-4", onDark ? "text-white" : "text-primary")} aria-hidden="true" />
      </span>
      {!compact ? (
        <div className="flex min-w-0 flex-col leading-tight">
          <span
            className={cn(
              "truncate text-[13px] font-medium tracking-normal",
              onDark ? "text-white" : "text-foreground",
            )}
          >
            {primaryLabel}
          </span>
          <span
            className={cn(
              "truncate text-[9px] font-normal lowercase tracking-tight",
              onDark ? "text-white/60" : "text-muted-foreground",
            )}
          >
            {secondaryLabel}
          </span>
        </div>
      ) : null}
    </div>
  );
};
